<template>
  <div class="follow-detail-page  ">
    <div class="top-info" >
      <div class="title">{{ $t('jiao-yi-yuan-xin-xi') }}</div>
      <div class="user-info" >
        <div class="flex-center-between info">
          <div class="flex-center">
            <div class="header">
              <img :src="headerUrl" alt="">
            </div>
            <div class="flex-1">
              <div class="name flex-center-start">
                <span>{{resetName(detailData.Name)}}</span>
              </div>
              <div class="email">
                {{resetEmail(detailData.Email)}}
              </div>
            </div>
          </div>
          <div class="flex-center btn">
            <div>{{ $t('follow.tab2') }}</div>
            <Button @click="toDetail">{{ $t('follow.btn1') }}</Button>
          </div>
        </div>
        <div class="flex-center-between user-statistics">
          <div class="box flex-column-start-center ">
            <div class="label">{{$t('follow.label1')}}(USDT)</div>
            <div class="count green">{{detailData.TotalProfit.toFixed(2)}}</div>
          </div>
          <div class="box flex-column-start-center ">
            <div class="label">{{$t('follow.label2')}}</div>
            <div class="count ">{{detailData.TotalTrade}}</div>
          </div>
          <div class="box flex-column-start-center ">
            <div class="label">{{$t('follow.label3')}}</div>
            <div class="count ">77/100</div>
          </div>
          <div class="box flex-column-end-center">
            <div class="label">{{$t('follow.label4')}}(USDT)</div>
            <div class="count green">{{detailData.TotalProfit.toFixed(2)}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="follow-user">
      <div class="tabs flex">
        <div class="tab" :class="orderIndex == i ? 'active' : ''" v-for="(item, i) in tabList" :key="i" @click="changeTab(i)">{{item}}</div>
      </div>
      <div class="list-box" v-if="orderIndex == 1 || orderIndex == 2">
        <div class="empty flex-column-center">
          <img :src="emptyUrl" alt="">
          <div class="desc">{{$t('common.empty')}}</div>
        </div>
      </div>

      <div class="list-box flex" v-show="orderIndex == 0">
        <div class="detail-info">
          <div class="title">{{ $t('shu-ju-gai-lan') }}</div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label15')}}</div>
            <div class="count">{{detailData.Type == 'contract' ? $t('followDetail.label17') : $t('followDetail.label16')}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label1')}}</div>
            <div class="count">{{detailData.TotalProfit}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label2')}}</div>
            <div class="count">{{detailData.Followers}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label3')}}</div>
            <div class="count">{{detailData.HistoryFollowers}}</div>
          </div>
          <div class="list-line border flex-center-between">
            <div class="label">{{$t('followDetail.label4')}}</div>
            <div class="count">{{detailData.FollowRatio}}%</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label5')}}</div>
            <div class="count">{{detailData.TotalTrade}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label6')}}</div>
            <div class="count">{{detailData.TotalProfitTrade}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label7')}}</div>
            <div class="count">{{detailData.TotalLossTrade}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label8')}}</div>
            <div class="count">{{detailData.TotalTradeDays}}</div>
          </div>
          <div class="list-line flex-center-between">
            <div class="label">{{$t('followDetail.label9')}}</div>
            <div class="count">{{detailData.Currency.ShortName}}</div>
          </div>
          <div class="list-line border flex-center-between">
            <div class="label">{{$t('followDetail.label10')}}</div>
            <div class="count">{{detailData.UpdatedAt}}</div>
          </div>
          
          <div class="list-line small">
            <div class="label">{{$t('followDetail.label11')}}</div>
            <div class="label">{{$t('followDetail.label12')}}</div>
          </div>
        </div>
        <div class="day-statistics flex-1">
          <div class="flex-start-between">
            <div class="title">{{ $t('shou-yieri-bao-biao') }}</div>
            <div class="text-right">
              <div class="day">{{ $t('today-ri-shou-yi', [today]) }}</div>
              <div class="count">5987.34</div>
            </div>
          </div>
          <div class="chart-dom" id="echartDom"></div>
        </div>
      </div>
      <div class="list-box" v-if="orderIndex == 3">
        <div class="list-table clear-bg mini">
          <div class="th-line flex-center-between">
            <div class="th flex-2">{{ $t('gen-dan-yuan') }}</div>
            <div class="th flex-2">{{ $t('zui-gao-gen-dan-ben-jin') }}</div>
            <div class="th flex-1 text-right">{{ $t('gen-dan-lei-ji-shou-yi-usdt') }}</div>
          </div>
          <div class="tbody">
            <div class="td-line flex-center-between" v-for="(item, i) in followUserList" :key="i" >
              <div class="td flex-2">tesaa***ald01@qq.com</div>
              <div class="td flex-2">{{item.count}}</div>
              <div class="td flex-1 text-right">{{parseFloat(item.count).toFixed(4)}}</div>
            </div>
          </div>
        </div>

        <pageBar :total="page.total" @changePage="changePage"></pageBar>
      </div>
    </div>
    
    <div class="page-modal follow" v-show="showModal">
      <tradeFollow :detailData="detailData" @cancel="cancel"></tradeFollow>
    </div>
  </div>
</template>
<script>
import { Button, Tabs, Tab } from 'vant'
import { copyTradeList } from '@/api/trade'
import { resetName, resetEmail } from '@/utils/common'
import moment from 'moment'
import * as echarts from 'echarts'
import pageBar from '@/components/pageBar'
import tradeFollow from './tradeFollow.vue'
export default {
  name: 'home',
  components: {
    Button,
    Tabs,
    Tab,
    pageBar,
    tradeFollow
  },
  data() {
    return {
      tabIndex: 1,
      userType: 1,
      orderIndex: 0,
      today: moment().format('YYYY-MM-DD'),
      eyeUrl: require('../../assets/imgs/icon-eye.png'),
      eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
      headerUrl: require('../../assets/imgs/icon-user.png'),
      emptyUrl: require('../../assets/imgs/icon-user.png'),
      followUserList: [
        {
          count: 123.33
        }, 
        {
          count: 433.33
        }, 
        {
          count: -23.33
        }, 
      ],
      showMoney: false,
      detailData: {
        Currency: {},
        TotalProfit: 0,
        TotalTrade: 0
      },
      dataId: '',
      echartDom: {},
      page: {
        page: 1,
        limit: 10,
        total: 1
      },
      showModal: false
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.index < from.meta.index) {
        this.transitionName = 'slide-right'
      } else if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      }

      let name = to.name
      if (name != 'trade') {
        this.menuIndex = -1
      }
    }
  },
  computed: {
    tabList() {
      return [`${this.$t('followDetail.tab1')}`, this.$t('followDetail.tab2'), this.$t('followDetail.tab3'), this.$t('followDetail.tab4')]
    }
  },
  mounted() {
    let index =  sessionStorage.getItem('followIndex')
    this.tabIndex = index || 1
    this.dataId = this.$route.query.id
    this.init()

    setTimeout(() => {
      this.initEchart()
    }, 1000)
  },
  methods: {
    resetEmail,
    resetName,
    init() {
      let form = new FormData()
      form.append('ID', this.dataId)
      copyTradeList(form).then(res => {
        let list = res.data.Items
        let index = list.findIndex(v => {
          return v.ID == this.dataId
        })
        if (index > -1) {
          this.detailData = res.data.Items[index] || {}
        }
      })
    },
    changePage(page) {
      this.page.page = page
      // this.initLog()
    },
    changeTab(i) {
      this.orderIndex = i
    },
    back() {
      this.$router.go(-1)
      sessionStorage.setItem('followIndex', 1)
    },
    changeMoneyType() {
      this.showMoney = !this.showMoney
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    changeType(type) {
      this.userType = type
    },
    toDetail() {
      this.$store.state.showModalBg = true
      this.showModal = true
    },
    cancel() {
      this.showModal = false
      this.$store.state.showModalBg = false
		},
    initEchart() {
      var echartDom = echarts.init(document.getElementById('echartDom'));
      
      let charData = [1003, 1100,-390,881,230,581,1239,1230,888,430,-330,-689]
      let xAxis = ['02-12', '02-13', '02-14', '02-15', '02-16', '02-17', '02-18', '02-19', '02-20', '02-21', '02-22', '02-23']
      const option = {
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: (e) => {
            let data = e[0].data
            let format = ''
            format += '<span>收益金额：</span>'
            format += '<span>' + data + '</span>'
            format += '<br>'
            format += '<span>交易次数：</span>'
            format += '<span>' + 12 + '</span>'
            return format 
          }
        },
        calculable: true,
        grid: {
          top: 40,
          right: 30,
          bottom: 40,
          left: 70
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          data: xAxis,
          axisLabel: {
            color: '#615E83'
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#615E83'
          },
          splitLine: {
            lineStyle: {
              color: '#f1f1f1'
            }
          }
        },
        series: [
          {
            name: this.$t('shou-yi-jin-e-0'),
            type: 'bar',
            barMaxWidth: '20',
            data: charData,
            itemStyle: {
              normal: {
                color: (e) => {
                  return e.data > 0 ? '#07C67B' : '#EB5757'
                }
              }
            }
          }
        ]
      };
      echartDom.setOption(option);
      this.echartDom = echartDom
    },
  }
}
</script>